import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../redux/store';
import { isValidEmail, isValidPositiveNumber } from '../../utils/validations';
import ButtonWithLoading from '../common/ButtomWIthLoading';
import { SalesForceServiceApi } from '../../service/salesForce.api';
import { SALES_UI_TEXT } from '../../constants/constants';
import { zenworksServiceApi } from '../../service/zenworksService.api';

interface DynamicContactDemoProps {
  data: any;
  handleFormSubmit: (response: any, formFields?: any) => void;
  option: any;
}
const clientType = process.env.REACT_APP_CLIENT;

const ContactDemo: React.FC<DynamicContactDemoProps> = ({
  data,
  handleFormSubmit,
  option,
}) => {
  const connectionStatus = useSelector(
    (state: RootState) => state.socketConnection.status,
  );
  const [isLoading, setIsLoading] = useState(false);
  const [form, setForm] = useState({
    email: '',
    name: '',
    formCount: '0',
  });
  const [error, setError] = useState('');

  const handleSubmit = async () => {
    setIsLoading(true);
    const reqBody = {
      email: form.email,
    };
    const userExists = await zenworksServiceApi.checkExist(reqBody);
    const formCount = Number(form.formCount);
    let numberofforms = '1001 to 10000';
    if (formCount > 10000) numberofforms = '10000 Plus';

    try {
      if (userExists.success) {
        handleFormSubmit(data.data[0].actionType, {
          ...form,
          formCount,
        });
      } else {
        if (formCount > 1000) {
          handleCreateLead(numberofforms);
          handleFormSubmit(data.data[1].actionType, {
            ...form,
            formCount,
          });
        } else {
          handleFormSubmit(data.data[0].actionType, {
            ...form,
            formCount,
          });
        }
      }
    } catch (error: any) {
      setError(error.message);
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleCreateLead = (numberofforms: string) => {
    SalesForceServiceApi.createLead({
      product: 'tax1099',
      leadtype: 'AI Chat',
      companyname: 'zenwork',
      firstname: null,
      lastname: null,
      email: form.email,
      contactnumber: 9999999999,
      numberofforms,
      interestedinapi: 'No',
      source: 'Organic',
      apilist: null,
      message: null,
      fullname: form.name,
      tinmatchvolume: null,
      tinmatchtype: null,
      w9Requestor1099filing: null,
      businesstype: null,
      accountingsoftware: null,
    });
  };

  const isFormValid =
    isValidEmail(form.email) &&
    form.name.trim() !== '' &&
    isValidPositiveNumber(form.formCount);

  let headerText = '';
  switch (option) {
    case 'contactDemo':
      headerText = SALES_UI_TEXT.BOOK_A_DEMO;
      break;
    case 'contactDiscountedPricing':
      headerText = SALES_UI_TEXT.DISCOUNTED_PRICING;
      break;
    default:
      headerText = SALES_UI_TEXT.BOOK_A_DEMO;
  }

  return (
    <div className="p-2">
      <div className="mb-1 font-medium text-left"> {headerText} </div>
      <div className="my-6 relative z-0 w-full ">
        <input
          name="firstName"
          type="text"
          id="firstName"
          placeholder=" "
          className="block py-2.5 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none focus:outline-none focus:ring-0 focus:border-[#6491C3] peer"
          value={form.name}
          onChange={(e) => setForm({ ...form, name: e.target.value })}
        />
        <label
          htmlFor="firstName"
          className="peer-focus:font-medium absolute text-sm text-gray-500 origin-left duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-0 peer-focus:left-0 peer-focus:text-[#6491C3] peer-focus:dark:text-[#114175] peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-8"
        >
          Your Name
        </label>
      </div>
      <div className="my-6 relative z-0 w-full ">
        <input
          name="Email"
          type="email"
          id="Email"
          placeholder=" "
          className="block py-2.5 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none focus:outline-none focus:ring-0 focus:border-[#6491C3] peer"
          value={form.email}
          onChange={(e) => setForm({ ...form, email: e.target.value })}
        />
        <label
          htmlFor="Email"
          className="peer-focus:font-medium absolute text-sm text-gray-500 origin-left duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-0 peer-focus:left-0 peer-focus:text-[#6491C3] peer-focus:dark:text-[#114175] peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-8"
        >
          Email Address
        </label>
      </div>
      <div className="my-6 relative z-0 w-full ">
        <input
          name="Form Count"
          type="number"
          id="formCount"
          placeholder=" "
          className="block py-2.5 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none focus:outline-none focus:ring-0 focus:border-[#6491C3] peer"
          value={form.formCount}
          onChange={(e) => setForm({ ...form, formCount: e.target.value })}
        />
        <label
          htmlFor="formCount"
          className="peer-focus:font-medium absolute text-sm text-gray-500 origin-left duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-0 peer-focus:left-0 peer-focus:text-[#6491C3] peer-focus:dark:text-[#114175] peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-8"
        >
          Form Count
        </label>
      </div>
      {error !== '' && (
        <div className=" mb-4 text-left text-red-500"> {error}</div>
      )}
      <ButtonWithLoading
        isLoading={isLoading}
        label="Block Sales Calendar"
        type="submit"
        className={`${clientType === 'salesbot2290ai' ? "bg-primary" : "bg-[#114175]"} text-white p-2  rounded-lg w-full mt-4 ${
          isFormValid ? (clientType === 'salesbot2290ai' ? "hover:bg-secondary" : "hover:bg-[#6491C3]") : 'cursor-not-allowed opacity-50'
        }`}
        disabled={!isFormValid || connectionStatus !== 'Connected'}
        onClick={handleSubmit}
      />
    </div>
  );
};

export default ContactDemo;
